import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Radio } from 'antd';
import { getFileImport } from '../redux-saga/selectors';
import { FileImportSourceVersion } from '../redux-saga/reducers';
import { fileImportActions } from '../redux-saga/actions';

export const FileImportSelectVersionStep: React.FC = () => {
  const dispatch = useDispatch();
  const { version, availableVersions } = useSelector(getFileImport);

  if (version != null) {
    return null;
  }

  return (
    <>
      <Radio.Group
        buttonStyle="solid"
        onChange={v => dispatch(fileImportActions.setState({ version: v.target.value }))}
      >
        {availableVersions.includes(FileImportSourceVersion.v1) && (
          <Radio.Button value={FileImportSourceVersion.v1}>FOS csv</Radio.Button>
        )}
        {availableVersions.includes(FileImportSourceVersion.v2) && (
          <Radio.Button value={FileImportSourceVersion.v2}>FOS xlsm</Radio.Button>
        )}
      </Radio.Group>
    </>
  );
};
